import React, { useState } from "react";
import { Link } from "react-router-dom";
import Cookies from "js-cookie";

const formatDate = (isoDate) => {
  const date = new Date(isoDate);
  return date.toLocaleDateString("en-GB", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });
};

const Sidebar = ({ relatedNews }) => {
  const [activeTab, setActiveTab] = useState("public");

  const [auth, setAuth] = useState(() => {
    const token = Cookies.get("token");
    const role = Cookies.get("role");
    const email = Cookies.get("email");
    return { token, role, email };
  });
  const isAuthenticated = !!(auth?.token && auth?.role && auth?.email);

  // Filter related news based on active tab
  const getFilteredRelatedNews = () => {
    if (!relatedNews) return [];

    if (!isAuthenticated) {
      return relatedNews.filter((item) => item.visibility === "public");
    }

    switch (activeTab) {
      case "public":
        return relatedNews.filter((item) => item.visibility === "public");
      case "private":
        return relatedNews.filter((item) => item.visibility === "private");
      case "all":
      default:
        return relatedNews;
    }
  };

  const filteredRelatedNews = getFilteredRelatedNews();

  const tabStyle = {
    borderRadius: "18px",
    padding: "5px 12px",
    fontWeight: "500",
    fontSize: "11px",
    border: "2px solid #e9ecef",
    marginRight: "5px",
    marginBottom: "6px",
    transition: "all 0.3s ease",
    textDecoration: "none",
    display: "inline-block",
    cursor: "pointer",
    backgroundColor: "white",
    color: "#6c757d",
  };

  const activeTabStyle = {
    ...tabStyle,
    backgroundColor: "#007bff",
    color: "white",
    border: "2px solid #007bff",
    boxShadow: "0 2px 6px rgba(0, 123, 255, 0.3)",
  };

  return (
    <div className="it-sv-details-sidebar">
      <div className="sidebar__widget mb-55">
        <div className="sidebar__widge-title-box">
          <h3 className="sidebar__widget-title pb-0">Latest news</h3>
        </div>

        <div className="sidebar__widget-content">
          <div className="sidebar__post">
            {filteredRelatedNews?.length > 0 ? (
              filteredRelatedNews.map((post) => (
                <div
                  key={post._id}
                  className="rc__post mb-10 d-flex align-items-start position-relative"
                >
                  {/* Privacy badge for authenticated users */}
                  {isAuthenticated && post.visibility === "private" && (
                    <div
                      style={{
                        position: "absolute",
                        top: "5px",
                        right: "5px",
                        zIndex: 10,
                        background: "linear-gradient(45deg, #dc3545, #e85a6b)",
                        color: "white",
                        padding: "2px 6px",
                        borderRadius: "10px",
                        fontSize: "8px",
                        fontWeight: "600",
                        textTransform: "uppercase",
                        letterSpacing: "0.3px",
                        boxShadow: "0 1px 3px rgba(220, 53, 69, 0.3)",
                      }}
                    >
                      <i
                        className="fa-solid fa-lock"
                        style={{ fontSize: "6px" }}
                      ></i>
                    </div>
                  )}

                  <div className="rc__post-thumb mr-20">
                    {/* Optional thumbnail */}
                    {post.imageUrl?.[0] && (
                      <img
                        src={post.imageUrl}
                        alt={post.title}
                        style={{
                          width: "60px",
                          height: "60px",
                          objectFit: "cover",
                        }}
                      />
                    )}
                  </div>
                  <div className="rc__post-content">
                    <div className="rc__meta">
                      <span>
                        <i className="fa-solid fa-calendar-days"></i>{" "}
                        {formatDate(post.date)}
                      </span>
                    </div>
                    <h3 className="rc__post-title">
                      <Link to={`/news-details?id=${post._id}&&title=${encodeURIComponent(post.title)}`}>
                        {post.title}
                      </Link>
                    </h3>
                  </div>
                </div>
              ))
            ) : (
              <div className="text-center py-3">
                <div
                  style={{
                    backgroundColor: "#f8f9fa",
                    border: "1px solid #dee2e6",
                    borderRadius: "8px",
                    padding: "15px",
                  }}
                >
                  <i
                    className="fa-solid fa-newspaper"
                    style={{
                      fontSize: "20px",
                      color: "#6c757d",
                      marginBottom: "5px",
                    }}
                  ></i>
                  <p style={{ color: "#6c757d", margin: 0, fontSize: "12px" }}>
                    No {activeTab === "all" ? "" : activeTab + " "}articles
                    found
                  </p>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Sidebar;
